export var BOSPEOSPContent;
(function (BOSPEOSPContent) {
    BOSPEOSPContent["Begin"] = "Begin";
    BOSPEOSPContent["End"] = "End";
})(BOSPEOSPContent || (BOSPEOSPContent = {}));
//# sourceMappingURL=SeaPassageContent.js.map